import styled from 'styled-components'
import { Styles as BaseStyles } from '~/pages/onboarding/quizBinaryChoice/libs/styles'
import { COLORS } from '~/shared/constants/uiConstants'

const RATING_BUTTON_DEFAULT_BG = '#e0e0e0'

export const Styles = {
  ...BaseStyles,

  RatingWrapper: styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
  `,

  RatingButtons: styled.div`
    display: flex;
    gap: 8px;
    justify-content: space-between;
  `,

  RatingButton: styled.button<{ $isSelected: boolean }>`
    width: 54px;
    height: 54px;
    background: ${({ $isSelected }) =>
      $isSelected ? COLORS.PURPLE_100 : RATING_BUTTON_DEFAULT_BG};
    color: ${COLORS.BLACK};
    border: 1px solid
      ${({ $isSelected }) => ($isSelected ? COLORS.PURPLE_500 : 'transparent')};
    border-radius: 8px;
    font-size: 18px;
    font-weight: 700;
    cursor: pointer;
    transition: background 0.15s ease, border-color 0.15s ease;
  `,

  RatingLabels: styled.div`
    display: flex;
    justify-content: space-between;
  `,

  RatingLabel: styled.span`
    font-size: 13px;
    line-height: 16px;
    color: ${COLORS.GRAY_700};
  `,
} as const
